import { render, staticRenderFns } from "./purchase-ledger.vue?vue&type=template&id=6f0587f8&scoped=true"
import script from "./purchase-ledger.vue?vue&type=script&lang=js"
export * from "./purchase-ledger.vue?vue&type=script&lang=js"
import style0 from "./purchase-ledger.vue?vue&type=style&index=0&id=6f0587f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0587f8",
  null
  
)

export default component.exports